const config = {
    backendUrl: String(process.env.REACT_APP_BACKEND_URL),
}

export default config
